import type { Locale } from '../context/LocaleContext';

export const SUPPORTED_LOCALES: Locale[] = ['zh', 'en'];

export function isSupportedLocale(value: string | undefined): value is Locale {
  return value === 'zh' || value === 'en';
}

export function getPreferredLocale(): Locale {
  try {
    const stored = localStorage.getItem('forprojourney_locale');
    if (stored === 'zh' || stored === 'en') {
      return stored;
    }
  } catch (_) {}

  try {
    const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
    const normalized = candidates.filter(Boolean).map((item) => item.toLowerCase());
    return normalized.some((item) => item.startsWith('zh')) ? 'zh' : 'en';
  } catch (_) {
    return 'en';
  }
}

export function withLocalePrefix(path: string, locale: Locale): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `/${locale}${normalized === '/' ? '' : normalized}`;
}

export function switchPathLocale(pathname: string, locale: Locale): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) {
    return `/${locale}`;
  }
  if (isSupportedLocale(parts[0])) {
    parts[0] = locale;
    return `/${parts.join('/')}`;
  }
  return `/${locale}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
}
